import { TimezoneTypes } from 'common/types/frequencySelector/frequencySelector';
import moment from 'moment-timezone';
import { defaultDateFormat } from '../constants/dateFormats';
import invert from 'lodash/invert';

const timezoneMap: Record<TimezoneTypes, string> = {
  cst: 'America/Chicago',
  est: 'America/New_York',
  mst: 'America/Denver',
  pst: 'America/Los_Angeles',
  utc: 'UTC',
};

export const mappedTimezone = (timeZone: TimezoneTypes): string => timezoneMap[timeZone] ?? 'UTC';

const invertedTimezoneMap = invert(timezoneMap) as Record<string, TimezoneTypes>;

export const reverseMappedTimezone = (tz: string | undefined): TimezoneTypes =>
  invertedTimezoneMap[tz as string] ?? 'utc';

export const isDateValidInTimezone = (date: string, timeZone: TimezoneTypes) => {
  const mappedTZ = mappedTimezone(timeZone);
  if (!mappedTZ) return false;

  const dateNowInTimezone = moment().tz(mappedTZ).format(defaultDateFormat);
  const selectedDate = moment(new Date(date)).format(defaultDateFormat);

  return selectedDate >= dateNowInTimezone;
};
